export default __webpack_public_path__ + "static/project-slide-6-4032-2268-3ec21ae1225e9ee5c5440252c03f9d75.webp";